module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-cn":{"accessDisableReasonTemp":"临时@:common.project不能设置访问限制为公众号或付费阅读","accessDisableReasonOverdate":"过期@:common.project不能修改访问限制规则"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/project/show/setting/form/access.card.vue
// module id = 340
// module chunks = 3